import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    width: 180px;
    border: 1px solid ${ThemeColors.gray5};
    border-radius: 5px;
`
